import { render, staticRenderFns } from "./TheCustomSidebar.vue?vue&type=template&id=424dad66&"
import script from "./TheCustomSidebar.vue?vue&type=script&lang=js&"
export * from "./TheCustomSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports